// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__18Fct","consentsList":"PatientConsents_consentsList__1AQ6x","consentsListEmpty":"PatientConsents_consentsListEmpty__3Aao6"};